export const messages = {
  // Navigation
  "nav.today": "Today",
  "nav.areas": "Areas",
  "nav.goals": "Goals",
  "nav.routines": "Routines",
  "nav.calendar": "Calendar",
  "nav.library": "Library",
  "nav.home": "Home",
  "nav.pricing": "Pricing",
  "nav.settings": "Settings",
  health: "Health",

  // Buttons
  "button.login": "Login",
  "button.register": "Register",
  "button.start_now": "Start Now",
  "button.continue": "Continue",
  "button.back": "Back",

  appDescription:
    "ProgressMade provides the tools to set goals, establish routines, and visualize your progress across all aspects of healthy living – from fitness and nutrition to mindfulness and sleep.",

  // Onboarding
  "onboarding.welcome_title": "Welcome to ProgressMade!",
  "onboarding.already_have_account": "Already have an account?",
  "onboarding.select_health_areas": "Select {healthAreas}",
  "onboarding.select_health_areas_description":
    "Which health areas are you interested in improving? Choose up to {maxAreas} health areas you'd like to focus on.",
  "onboarding.select_health_areas_counter_empty": "Tap on the areas that matter to you",
  "onboarding.select_health_areas_counter": "{selected} of {max} health areas selected",
  "onboarding.calendar_setup": "Set Up Your {calendar}",
  "onboarding.calendar_setup_description": "Choose how you want your calendar to look and work.",
  "onboarding.notifications": "Notifications",
  "onboarding.notifications_description":
    "Turn on notifications that keep you moving towards your best self. You can do it!",
  "onboarding.user_segmentation_title": "What does {health} mean to you?",
  "onboarding.user_segmentation_subtitle": "Select all that apply",
  "onboarding.referral_source_title": "How did you hear about {appName}?",
  "onboarding.profile_setup": "Complete your profile",
  "onboarding.create_routine": "Create your first routine",
  "onboarding.create_routine_description":
    "Start building healthy habits that stick. Design a routine that fits your lifestyle and helps you achieve your wellness goals.",
  "onboarding.feature_overview.habit_streaks.title": "Habit Streaks",
  "onboarding.feature_overview.habit_streaks.description":
    "Stay motivated by tracking your habit streaks and building lasting habits. See your progress unfold as you maintain daily routines and reach new milestones.",
  "onboarding.feature_overview.health_calendar.title": "Health Calendar",
  "onboarding.feature_overview.health_calendar.description":
    "Your routines and goals are automatically scheduled in your calendar. See your wellness activities alongside your daily schedule for better time management.",
  "onboarding.feature_overview.smart_notifications.title": "Smart Notifications",
  "onboarding.feature_overview.smart_notifications.description":
    "Receive timely reminders for your health routines and motivational messages to keep you on track with your goals.",
  "onboarding.referral_options.social_media": "Social Media",
  "onboarding.referral_options.friend_family": "Friend or Family",
  "onboarding.referral_options.search_engine": "Search Engine",
  "onboarding.referral_options.blog_article": "Blog or Article",
  "onboarding.referral_options.health_professional": "Health Professional",
  "onboarding.referral_options.app_store": "App Store",
  "onboarding.referral_options.advertisement": "Advertisement",
  "onboarding.referral_options.somewhere_else": "Somewhere else",
  "onboarding.referral_other_placeholder": "Tell us how you discovered ProgressMade...",
  "onboarding.user_segments.energy_vitality": "Having energy and vitality every day",
  "onboarding.user_segments.balanced_lifestyle": "Maintaining a balanced lifestyle",
  "onboarding.user_segments.mental_emotional": "Feeling mentally and emotionally well",
  "onboarding.user_segments.physical_fitness": "Being physically strong and fit",
  "onboarding.user_segments.sleep_rest": "Having good sleep and rest",
  "onboarding.user_segments.nutrition": "Eating nourishing foods",
  "onboarding.user_segments.stress_management": "Managing stress effectively",
  "onboarding.button.select_areas": "Select Areas",
  "onboarding.button.select_option": "Select an option",
  "onboarding.button.select_at_least_one": "Select at least one option",

  // Cookie Consent
  "cookie.title": "But first, cookies 🍪",
  "cookie.description":
    "We use essential cookies for our service to function properly and collect anonymous usage data to improve your experience.",
  "cookie.accept": "Accept & Continue",
  "cookie.error": "Failed to save cookie consent",

  // Homepage
  "home.hero.feature_badges.boost_energy": "Boost Daily Energy",
  "home.hero.feature_badges.transform_sleep": "Transform Your Sleep",
  "home.hero.feature_badges.feel_better": "Feel Better Every Day",
  "home.hero.heading": "Schedule Your Health",
  "home.hero.subheading":
    "ProgressMade is the {googleCalendar} for your health. Wake up with more energy. Feel confident in your nutrition choices. Crush your workouts.",
  "home.hero.google_calendar": "Google Calendar",
  "home.hero.start_now": "Start Now",
  "home.hero.download_app_store": "Download on App Store",
  "home.hero.download_google_play": "Download on Google Play",
  "home.hero.social_proof.see_stories": "See Success Stories",
  "home.hero.social_proof.app_store_rating": "App Store rating",
  "home.hero.start_button_title": "Get started with ProgressMade.ai - Begin your health journey",
  "home.hero.download_button_title": "Download ProgressMade.ai from the App Store",
  "home.hero.image_alt":
    "ProgressMade.ai mobile app interface showing health tracking and wellness features",

  // Goals
  "goals.1": "Awaken Your Body with a 10-minute morning stretch.",
  "goals.2": "Fuel Your Afternoon by packing a protein-rich, veggie-filled lunch.",
  "goals.3": "Prepare for Deep Sleep by switching to night mode an hour before bed.",
  "goals.4": "Kickstart Your Metabolism by hydrating and fueling up first thing.",
  "goals.5": "Find Your Calm with a 5-minute breathing exercise when stress hits.",
  "goals.6": "Reset Your Focus with a 10-minute midday movement break.",
  "goals.7": "Boost Your Vitality with a serving of fresh fruit.",
  "goals.8": "Choose Clean Energy by swapping one sugary drink for water.",
  "goals.9": "Stay Effortlessly Hydrated by keeping a water bottle within reach.",
  "goals.10": "Digest and De-stress with a gentle 15-minute walk after dinner.",
  "goals.11": "Reclaim Your Lunch Break by eating mindfully, away from your screen.",
  "goals.12": "Release Office Tension with a quick neck and shoulder stretch.",
  "goals.13": "Nourish from Within by adding a handful of greens to your dinner.",
  "goals.14": "Plan for Success by prepping a healthy snack for tomorrow.",
  "goals.15": "Find Fitness in the Everyday by choosing the stairs.",
  "goals.16": "Break Up a Sedentary Day by standing and moving every hour.",

  // Features
  "features.title": "Your Health In Check",
  "features.description":
    "ProgressMade gives your health the same structure and clarity as your calendar. It turns your good intentions into a reliable plan, helping you build powerful momentum day after day. Achieve lasting results by making consistency your new default.",
  "features.calendar.title": "Plan your healthy activities",
  "features.calendar.description":
    "Our {healthCalendar} helps you plan workouts, nutrition, mental and other {healthyActivities} that help you create {lifelongHealthyHabits}.",
  "features.calendar.health_calendar": "health calendar",
  "features.calendar.healthy_activities": "healthy activities",
  "features.calendar.lifelong_healthy_habits": "lifelong healthy habits",
  "features.calendar.schedule_routines": "Schedule routines",
  "features.calendar.identify_patterns": "Identify optimal patterns",
  "features.calendar.visualize_progress": "Visualize progress",
  "features.goals.title": "Health goals that matter to you",
  "features.goals.description":
    "Set meaningful {healthGoals} tailored to your needs. Experience tangible improvements in fitness and energy while building confidence through {dailyProgress}.",
  "features.goals.health_goals": "health goals",
  "features.goals.daily_progress": "daily progress",
  "features.notifications.title": "Notifications to keep you moving",
  "features.notifications.description":
    "{consistency} is the key to success in health and longevity. That's why we've built {smartNotifications} that adapt to your schedule and keep you on track.",
  "features.notifications.consistency": "Consistency",
  "features.notifications.smart_notifications": "smart notifications",
  "features.notifications.build_habits": "Build consistent habits",
  "features.notifications.personalized_nudges": "Personalized nudges",
  "features.notifications.milestone_celebrations": "Milestone celebrations",
  "features.ai.title": "Organize your health with AI",
  "features.ai.description":
    "ProgressMade integrates an AI coach that learns your unique patterns and {nudgesYou} offering guidance when you need it most, regardless of fitness level.",
  "features.ai.nudges_you": "nudges you to take action",
  "features.ai.creates_routines": "Creates personalized routines",
  "features.ai.sets_milestones": "Sets achievable milestones",
  "features.ai.breaks_down_goals": "Breaks down health goals into simple daily actions",
  "features.streaks.title": "Habit Streaks",
  "features.streaks.description":
    "Stay motivated by tracking your {consistencyStreaks} and building {lastingHabits}. See your progress unfold as you maintain daily routines and reach new milestones.",
  "features.streaks.consistency_streaks": "consistency streaks",
  "features.streaks.lasting_habits": "lasting habits",
  "features.streaks.track_consistency": "Track daily consistency",
  "features.streaks.celebrate_milestones": "Celebrate milestones",
  "features.streaks.visualize_progress": "Visualize progress",

  // Social Proof
  "socialProof.title": "Trusted by health-conscious users",
  "socialProof.description":
    "From better sleep quality to increased energy, our community is achieving real results every day.",
  "socialProof.lovedByCommunity": "Loved by our community",
  "socialProof.joinGrowingCommunity": "Join our growing community",
  "socialProof.verifiedUser": "Verified User",
  "socialProof.testimonials.angela":
    "Motivated to go for a walk today thanks to ProgressMade. I want to input my completed routines tonight and receive the confetti reward! The psychological stick behind the door works for me.",
  "socialProof.testimonials.esmee":
    "I've been using ProgressMade for a few weeks now and it's been a game-changer for me. I've been able to stick to my goals and achieve them consistently. The app is easy to use.",
  "socialProof.testimonials.david":
    "ProgressMade has been a game-changer for someone like me who found consistency challenging. It helps identify my patterns, sends timely reminders, and the health calendar's visual feedback and milestone celebrations make staying on track rewarding.",

  // CTA Section
  "cta.title": "Concerns about your health?",
  "cta.description":
    "Take control of your wellness journey. Build healthier habits, track your progress, and achieve lasting results with personalized health routines.",
  "cta.start_now": "Start Now",
  "cta.image_alt":
    "ProgressMade.ai app interface displaying personalized health routines and wellness tracking features",

  // FAQ Section
  "faq.title": "Frequently Asked Questions",
  "faq.description": "Get quick answers about ProgressMade.AI.",
  "faq.have_another_question": "Have another question?",
  "faq.contact_description": "Contact us on {whatsappCommunityUrl} or by email at {email}",
  "faq.contact_button": "Contact",

  // FAQ Sections
  "faq.sections.discovery": "Discovery",
  "faq.sections.features": "Features",
  "faq.sections.personalization": "Personalization",
  "faq.sections.benefits": "Benefits",
  "faq.sections.ease": "Ease of Use",
  "faq.sections.pain": "Pain Points",

  // FAQ Questions & Answers - Discovery
  "faq.d1.question": "Is there an AI app that helps me build a daily routine?",
  "faq.d1.answer":
    "Yes! ProgressMade.ai is designed to help you build and maintain a daily routine using advanced AI. It analyzes your goals and lifestyle to create personalized routines that are easy to follow and adapt as you progress, making it the perfect companion for anyone looking to optimize their health habits.",
  "faq.d2.question": "What are the best apps for tracking health habits?",
  "faq.d2.answer":
    "ProgressMade.ai stands out as the best app for tracking health habits. It combines powerful AI with an intuitive interface, allowing you to monitor your routines, receive personalized suggestions, and see real progress in your wellbeing—all in one place.",
  "faq.d3.question": "I need an app to help me stick to my fitness goals.",
  "faq.d3.answer":
    "ProgressMade.ai is built to help you stay consistent with your fitness goals. The app uses AI to create tailored routines, send reminders, and provide motivational feedback, ensuring you stay on track and achieve lasting results.",
  "faq.d4.question": "Are there any apps that use AI to personalize my health plan?",
  "faq.d4.answer":
    "Absolutely! ProgressMade.ai uses advanced AI to personalize your health plan based on your unique needs, preferences, and progress. It continuously adapts your routines to maximize your results and keep you motivated.",
  "faq.d5.question": "Looking for an app to create and manage healthy habits.",
  "faq.d5.answer":
    "ProgressMade.ai is the ideal app for creating and managing healthy habits. Its AI-driven approach helps you set, track, and refine your habits, making it easier than ever to build a healthier lifestyle.",
  "faq.d6.question": "How can an app help me be more consistent with my health?",
  "faq.d6.answer":
    "ProgressMade.ai helps you stay consistent by providing personalized routines, timely reminders, and motivational feedback. The AI learns from your behavior and adjusts your plan to keep you engaged and progressing toward your goals.",

  // FAQ Questions & Answers - Features
  "faq.f1.question": "How does ProgressMade.ai use AI to set routines?",
  "faq.f1.answer":
    "ProgressMade.ai uses AI to analyze your goals, preferences, and progress, then generates daily routines tailored specifically for you. The routines evolve as you use the app, ensuring they remain effective and achievable.",
  "faq.f2.question": "Can ProgressMade.ai create a personalized health plan for me?",
  "faq.f2.answer":
    "Yes, ProgressMade.ai creates a personalized health plan by understanding your unique needs and goals. The AI crafts routines and habits that fit your lifestyle, making your health journey truly individualized.",
  "faq.f3.question": "Does the app track my progress on different habits?",
  "faq.f3.answer":
    "ProgressMade.ai tracks your progress on all your habits, providing clear insights and visualizations. This helps you see your improvements over time and identify areas for further growth.",
  "faq.f4.question": "Can I set reminders for my routines?",
  "faq.f4.answer":
    "Absolutely! ProgressMade.ai allows you to set custom reminders for your routines, ensuring you never miss a step on your health journey.",
  "faq.f5.question": "Does it offer suggestions for new healthy habits?",
  "faq.f5.answer":
    "Yes, the AI in ProgressMade.ai suggests new healthy habits based on your progress and interests, helping you continuously improve your wellbeing.",
  "faq.f6.question": "Can I integrate ProgressMade.ai with other fitness trackers or apps?",
  "faq.f6.answer":
    "ProgressMade.ai is designed to work alongside your favorite fitness trackers and health apps, making it easy to sync your data and get a complete view of your health.",
  "faq.f7.question": "How does the app handle when I miss a routine?",
  "faq.f7.answer":
    "If you miss a routine, ProgressMade.ai's AI will adjust your plan and provide gentle reminders and encouragement, helping you get back on track without guilt.",
  "faq.f8.question": "Does it provide motivation or feedback?",
  "faq.f8.answer":
    "ProgressMade.ai offers motivational feedback and celebrates your achievements, keeping you inspired and engaged throughout your health journey.",
  "faq.f9.question":
    "Can I customize the types of habits I want to track (e.g., exercise, nutrition, sleep, mindfulness)?",
  "faq.f9.answer":
    "Yes, ProgressMade.ai lets you fully customize the habits you track, including exercise, nutrition, sleep, mindfulness, and more. The app adapts to your unique health priorities.",

  // FAQ Questions & Answers - Personalization
  "faq.p1.question": "How does the AI learn about my habits and preferences?",
  "faq.p1.answer":
    "The AI in ProgressMade.ai learns from your daily inputs, progress, and feedback. Over time, it builds a detailed understanding of your habits and preferences, allowing it to offer increasingly personalized recommendations.",
  "faq.p2.question": "Can the AI adjust my routine based on my progress or mood?",
  "faq.p2.answer":
    "Yes, ProgressMade.ai's AI adapts your routines based on your progress and even your mood, ensuring your plan always fits your current needs and keeps you motivated.",
  "faq.p3.question": "Does the AI provide insights into my habit patterns?",
  "faq.p3.answer":
    "ProgressMade.ai provides actionable insights into your habit patterns, helping you understand what's working and where you can improve for better results.",
  "faq.p4.question": "Can the AI help me identify why I'm struggling with certain habits?",
  "faq.p4.answer":
    "Yes, the AI analyzes your data to identify obstacles and offers practical solutions, making it easier to overcome challenges and build lasting habits.",
  "faq.p5.question": "How does the AI ensure the routines it suggests are achievable for me?",
  "faq.p5.answer":
    "ProgressMade.ai's AI considers your lifestyle, preferences, and progress to suggest routines that are realistic and achievable, helping you build confidence and consistency.",

  // FAQ Questions & Answers - Benefits
  "faq.b1.question": "How can ProgressMade.ai help me be more consistent?",
  "faq.b1.answer":
    "ProgressMade.ai keeps you consistent by providing personalized routines, reminders, and motivational feedback, all tailored to your unique journey.",
  "faq.b2.question": "Will this app help me achieve my health goals faster?",
  "faq.b2.answer":
    "Yes, ProgressMade.ai accelerates your progress by using AI to optimize your routines and keep you focused on what matters most, helping you reach your health goals more efficiently.",
  "faq.b3.question": "How can an AI routine help me build lasting habits?",
  "faq.b3.answer":
    "AI routines in ProgressMade.ai adapt to your needs and progress, making it easier to stick with new habits and turn them into lasting lifestyle changes.",
  "faq.b4.question": "What are the benefits of using an AI-powered habit tracker?",
  "faq.b4.answer":
    "An AI-powered habit tracker like ProgressMade.ai offers personalized guidance, adapts to your progress, and provides insights that help you achieve better results than generic apps.",
  "faq.b5.question": "Will using ProgressMade.ai reduce stress related to managing my health?",
  "faq.b5.answer":
    "Yes, ProgressMade.ai simplifies health management by organizing your routines and providing clear, actionable steps, reducing stress and making your journey enjoyable.",

  // FAQ Questions & Answers - Ease of Use
  "faq.e1.question": "Is ProgressMade.ai easy to use?",
  "faq.e1.answer":
    "ProgressMade.ai is designed for simplicity and ease of use, with an intuitive interface that makes managing your health routines effortless for everyone.",
  "faq.e2.question": "Is the app available on iOS and Android?",
  "faq.e2.answer":
    "ProgressMade.ai is available on both iOS and Android, so you can manage your health routines wherever you are.",
  "faq.e3.question": "Is there a free trial or free version?",
  "faq.e3.answer":
    "Yes, ProgressMade.ai offers a free version with essential features, so you can start improving your health at no cost. Upgrade to Pro for advanced AI insights and unlimited routines.",
  "faq.e4.question": "What is the cost of the app?",
  "faq.e4.answer":
    "ProgressMade.ai offers a free plan and affordable Pro options. Visit our pricing page for the latest pricing details and choose the plan that fits your needs.",
  "faq.e5.question": "How is user data handled and is it private?",
  "faq.e5.answer":
    "Your privacy is our top priority. ProgressMade.ai uses enterprise-grade encryption and strict privacy policies to keep your data safe and confidential.",

  // FAQ Questions & Answers - Pain Points
  "faq.u1.question": "I struggle with consistency. Can ProgressMade.ai help?",
  "faq.u1.answer":
    "Absolutely! ProgressMade.ai is designed to help you build consistency with personalized routines, reminders, and motivational support tailored to your needs.",
  "faq.u2.question": "I don't know where to start with building a healthy routine.",
  "faq.u2.answer":
    "ProgressMade.ai guides you step-by-step, making it easy to start building healthy routines, even if you're a complete beginner.",
  "faq.u3.question":
    "I feel overwhelmed by all the health advice out there. Can the app simplify it?",
  "faq.u3.answer":
    "Yes, ProgressMade.ai cuts through the noise by providing clear, personalized routines and actionable steps, so you can focus on what works for you.",
  "faq.u4.question": "I lose motivation easily. Can the app keep me engaged?",
  "faq.u4.answer":
    "ProgressMade.ai keeps you engaged with motivational feedback, progress tracking, and adaptive routines that evolve with your journey.",
  "faq.u5.question": "I have a busy schedule. Can the app create a routine that fits?",
  "faq.u5.answer":
    "Yes, ProgressMade.ai creates routines that fit your busy lifestyle, ensuring you can make progress no matter how hectic your schedule is.",

  // Footer
  "footer.downloadAppStore": "Download on the App Store",
  "footer.downloadGooglePlay": "Download on Google Play",
  "footer.aboutUs": "About Us",
  "footer.contact": "Contact",
  "footer.pricing": "Pricing",
  "footer.blog": "Blog",
  "footer.changelog": "Changelog",
  "footer.newsletter": "Newsletter",
  "footer.compare": "Compare",
  "footer.affiliateProgram": "Affiliate Program",
  "footer.tools": "Tools",
  "footer.iphoneApp": "iPhone App",
  "footer.androidApp": "Android App",
  "footer.webApp": "Web App",
  "footer.progressCalendars": "Progress Calendars",
  "footer.features": "Features",
  "footer.healthCalendar": "Health Calendar",
  "footer.healthRoutines": "Health Routines",
  "footer.healthGoals": "Health Goals",
  "footer.healthThemes": "Health Themes",
  "footer.copyright": "© {year} {appName}. All rights reserved.",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.termsOfService": "Terms of Service",
  "footer.googlePlayTrademark":
    "Google Play and the Google Play logo are trademarks of Google LLC.",
  "footer.instagramProfile": "Instagram Profile",
  "footer.whatsappCommunity": "WhatsApp Community",
  "footer.linkedinProfile": "LinkedIn Profile",
  "footer.tiktokProfile": "TikTok Profile",
  "footer.xProfile": "X (formerly Twitter) Profile",

  // Common
  "common.error": "Error",
  "common.success": "Success",
  "common.and": "and",

  // Settings - Notifications
  "settings.notifications.title": "Notifications",
  "settings.notifications.enable_all": "Enable all notification types",
  "settings.notifications.disable_all": "Disable all notification types",
  "settings.notifications.no_fcm_token.title": "No FCM Token",
  "settings.notifications.no_fcm_token.description":
    "You have enabled notifications, but you have no FCM token. Please enable notifications again.",
  "settings.notifications.todays_routines.title": "Today's Routines",
  "settings.notifications.todays_routines.description":
    "Notify me in the morning (8:00 AM local time) a summary of today's routines.",
  "settings.notifications.routine_reminder.title": "Routine Reminders",
  "settings.notifications.routine_reminder.description":
    "Notify me a few minutes before a scheduled routine starts.",
  "settings.notifications.show_preview": "Show Preview",
  "settings.notifications.update_error":
    "Failed to update notification settings. Please try again.",
  "settings.notifications.update_single_error": "Failed to update '{label}'. Please try again.",
  "settings.notifications.example.todays_routines.name": "Today's Routines",
  "settings.notifications.example.todays_routines.description":
    "Get ready for: Morning Run, Green Smoothie, Winddown Routine.",
  "settings.notifications.example.todays_routines.time": "8:00 AM",
  "settings.notifications.example.routine_reminder.name": "Morning Run Reminder",
  "settings.notifications.example.routine_reminder.description":
    "Your Morning Run starts in 5 minutes!",
  "settings.notifications.example.routine_reminder.time": "9:55 AM",

  // Settings - Calendar
  "settings.calendar.time_format": "Time Format",
  "settings.calendar.time_format.placeholder": "Choose your time format",
  "settings.calendar.time_format.12h": "12-hour (8:00 AM)",
  "settings.calendar.time_format.24h": "24-hour (08:00)",
  "settings.calendar.week_starts_on": "Week Starts On",
  "settings.calendar.week_starts_on.placeholder": "Choose your week start",
  "settings.calendar.week_starts_on.sunday": "Sunday",
  "settings.calendar.week_starts_on.monday": "Monday",
  "settings.calendar.timezone": "Timezone",
  "settings.calendar.timezone.placeholder": "Select your timezone",
  "settings.calendar.timezone.description": "We'll use this for accurate scheduling and reminders.",
  "settings.calendar.save_settings": "Save Settings",
  "settings.calendar.update_error": "Failed to update your calendar settings. Please try again.",
  "settings.calendar.update_success": "Your calendar settings have been updated successfully.",

  // Auth Dialogs
  "auth.register.title": "Register",
  "auth.register.description":
    "Join for free and start building your perfect health routines today!",
  "auth.register.continue_with_email": "Continue with Email",
  "auth.login.title": "Login",
  "auth.login.description": "Welcome back! Dive back into your routines and keep making progress.",
  "auth.login.continue_with_email": "Login with Email",
  "auth.forgot_password.title": "Forgot Password",
  "auth.forgot_password.description": "Enter your email to receive a reset password link.",

  // Auth Buttons
  "auth.buttons.continue_with_apple": "Continue with Apple",
  "auth.buttons.login_with_apple": "Login with Apple",
  "auth.buttons.continue_with_google": "Continue with Google",
  "auth.buttons.login_with_google": "Login with Google",
  "auth.buttons.continue_with_email": "Continue with Email",
  "auth.buttons.login_with_email": "Login with Email",
  "auth.buttons.apple_signin_failed": "Apple sign-in failed",
  "auth.buttons.google_signin_failed": "Google sign-in failed",

  // Legal Links
  "legal.agreement_text": "By continuing, you agree to {appName}",
  "legal.terms_of_service": "Terms of Service",
  "legal.privacy_policy": "Privacy Policy",
  "legal.read_our": "Read our",

  // Contact Form
  "contact.feedbackDialog.title": "Provide Feedback",
  "contact.feedback_description":
    "We improve based on your feedback. You can also email us directly at",
  "contact.your_email": "Your Email",
  "contact.email_placeholder": "your@email.com",
  "contact.message": "Message",
  "contact.message_placeholder": "What would you like to tell us?",
  "contact.submit_message": "Submit Message",
  "contact.success_title": "Success",
  "contact.success_description": "Your message has been sent. We'll get back to you soon!",
  "contact.error_title": "Error",
  "contact.error_description": "There was an error sending your message. Please try again.",
  "contact.message_min_length": "Message must be at least 5 characters",
  "contact.email_invalid": "Please enter a valid email address",

  // Register Form
  "register.your_name": "Your name",
  "register.name_placeholder": "Full name...",
  "register.name_description": "This is your public display name.",
  "register.email": "Email",
  "register.email_placeholder": "me@example.com",
  "register.password": "Password",
  "register.password_placeholder": "****",
  "register.register_button": "Register",
  "register.already_have_account": "Already have an account? Login",
  "register.name_min_length": "Your name must be at least 2 characters long",
  "register.email_invalid": "Invalid email address",
  "register.password_min_length": "Password must be at least 8 characters long",
  "register.registration_failed":
    "Registration failed. Please check your details or try logging in.",

  // Profile Form
  "profile.your_name": "Your name",
  "profile.name_placeholder": "Your name",
  "profile.name_description":
    "This is the name that will be displayed on your profile and in emails.",
  "profile.interface_language": "Language",
  "profile.interface_language_placeholder": "Select your preferred interface language",
  "profile.interface_language_description":
    "This is the language for the platform interface and navigation.",
  "profile.ai_model_language": "AI Model Language",
  "profile.ai_model_language_placeholder": "Select your preferred AI language",
  "profile.ai_model_language_description":
    "This is the language the AI will use when communicating with you and generating responses.",
  "profile.allow_marketing_mail": "Emails",
  "profile.allow_marketing_mail_description":
    "Receive updates about new features, health tips, and content from ProgressMade.",
  "profile.update_profile": "Update Profile",
  "profile.update_error": "Failed to update your profile. Please try again.",
  "profile.update_success": "Your profile has been updated successfully.",
  "profile.name_min_length": "Full name must be at least 2 characters long",
  "profile.language_required": "Please select a language",
  "profile.ai_language_required": "Please select a language for the AI",

  // Newsletter Form
  "newsletter.your_name": "Your name",
  "newsletter.name_placeholder": "Your name",
  "newsletter.email": "Email",
  "newsletter.email_placeholder": "Enter your email...",
  "newsletter.join_newsletter": "Join the Newsletter",
  "newsletter.already_subscribed": "Already Subscribed",
  "newsletter.already_subscribed_description":
    "This email address is already subscribed to our newsletter.",
  "newsletter.subscription_failed": "Subscription Failed",
  "newsletter.subscription_failed_description": "Something went wrong. Please try again.",
  "newsletter.subscribed": "Subscribed!",
  "newsletter.subscribed_description": "Thanks for signing up! Check your inbox for updates.",
  "newsletter.name_required": "Name is required",
  "newsletter.email_invalid": "Please enter a valid email address",

  // Pro Component
  "pro.title": "ProgressMade Health Pro",
  "pro.subtitle": "Unlock Your Path to Better Health and Energy",
  "pro.subtitle_personalized": "{name}, unlock your path to better health and energy",
  "pro.monthly": "Monthly",
  "pro.yearly": "Yearly",
  "pro.save_percentage": "Save {percentage}%",
  "pro.per_day": "Only {price} per day",
  "pro.billed_annually": "{price} billed annually",
  "pro.secure_payment": "Secure payment powered by {provider}",
  "pro.continue_with_apple_pay": "Continue with Apple Pay",
  "pro.continue_with_stripe": "Continue with Stripe",
  "pro.continue_with_google_play": "Continue with Google Play",
  "pro.restore_purchases": "Restore Purchases",
  "pro.error_creating_checkout": "Error creating checkout session",
  "pro.no_purchases_to_restore": "No purchases to restore",

  // Sidebar
  "sidebar.today": "Today",
  "sidebar.health_areas": "Health Areas",
  "sidebar.goals": "Goals",
  "sidebar.routines": "Routines",
  "sidebar.calendar": "Calendar",
  "sidebar.library": "Library",
  "sidebar.pro_member": "Pro Member",
  "sidebar.free_member": "Free Member",
  "sidebar.notification_settings": "Notification Settings",
  "sidebar.calendar_settings": "Calendar Settings",
  "sidebar.profile": "Profile",
  "sidebar.account": "Account",
  "sidebar.log_out": "Log out",
  "sidebar.go_to_home": "Go to Home",
  "sidebar.share_with_friend": "Share with a friend",
  "sidebar.upgrade_to_pro": "Upgrade to Pro",
  "sidebar.provide_feedback": "Provide Feedback",
  "sidebar.add_routine": "Add Routine",
  "sidebar.add_goal": "Add Goal",
  "sidebar.add_health_area": "Add Health Area",
  "sidebar.edit_delete_more": "Edit, delete and more...",
  "sidebar.thanks_for_sharing": "Thanks for sharing!",
  "sidebar.friend_notified": "Your friend has been notified.",
  "sidebar.link_copied": "Link copied to clipboard!",
  "sidebar.share_link_description": "You can now share this link with a friend.",
  "sidebar.unable_to_share": "Unable to share",
  "sidebar.copy_url_manually": "Please manually copy the URL from your browser's address bar.",
  "sidebar.share_failed": "Share failed",
  "sidebar.share_failed_description": "Please try again or manually copy the URL.",

  // Pricing
  "pricing.free.name": "Free",
  "pricing.free.description": "Start your health journey",
  "pricing.free.period": "forever",
  "pricing.free.track_health_areas": "Track up to {count} health areas",
  "pricing.free.track_goals": "Track up to {count} goals",
  "pricing.free.manage_routines": "Manage up to {count} routines",
  "pricing.free.ai_suggestions": "Receive {count} AI suggestions",
  "pricing.free.basic_insights": "Basic health insights and tracking",
  "pricing.free.core_tools": "Access to core health improvement tools",
  "pricing.pro.name": "Pro",
  "pricing.pro.description": "Unlock your best self with unlimited access and personalization",
  "pricing.pro.everything_free": "Everything in Free",
  "pricing.pro.unlimited_health_areas": "Unlimited Health Areas",
  "pricing.pro.unlimited_goals": "Unlimited Goals",
  "pricing.pro.unlimited_routines": "Unlimited Routines",
  "pricing.pro.unlimited_ai": "Unlimited AI-powered insights and suggestions",
  "pricing.pro.advanced_analytics": "Advanced analytics with personalized coaching",
  "pricing.pro.calendar_integration": "Full calendar integration and scheduling",

  // Pricing Page
  "pricing.page.title": "Pricing",
  "pricing.page.description":
    "Invest in your {healthTransformation}. Get personalized guidance and advanced tools to achieve real improvements in your health and fitness.",
  "pricing.page.health_transformation": "health transformation",
  "pricing.page.monthly": "Monthly",
  "pricing.page.yearly": "Yearly",
  "pricing.page.save_percentage": "Save 35%",
  "pricing.page.get_started": "Get Started",
  "pricing.page.summer_deal": "Summer Is Coming Deal",
  "pricing.page.upgrade_to_pro": "Upgrade to Pro",
  "pricing.page.billed_yearly": "(billed yearly)",

  // Page Titles and Descriptions
  "pages.account.title": "My Account",
  "pages.account.description": "Update your email, change your password, or delete your account.",
  "pages.profile.title": "My Profile",
  "pages.profile.description": "Update your personal information and customize your profile.",
  "pages.calendar_settings.title": "Calendar Settings",
  "pages.calendar_settings.description":
    "Update your calendar settings to keep your calendar accurate and up-to-date.",
  "pages.notification_settings.title": "Notification Settings",
  "pages.notification_settings.description":
    "Update your notification settings to keep your notifications accurate and up-to-date.",

  // Account Page Components
  "account.pro_status.title": "Pro Status",
  "account.pro_status.description": "Your current subscription status and billing information.",
  "account.pro_status.status": "Status",
  "account.pro_status.plan": "Plan",
  "account.pro_status.next_billing_date": "Next billing date",
  "account.pro_status.pro_access_until": "Pro access until",
  "account.pro_status.cancel_subscription": "Cancel Subscription",
  "account.pro_status.status_pro": "Pro",
  "account.pro_status.status_pro_canceled": "Pro (Canceled)",
  "account.pro_status.status_free": "Free",
  "account.pro_status.plan_monthly": "Monthly Billing",
  "account.pro_status.plan_yearly": "Yearly Billing",
  "account.pro_status.cancel_description":
    "Your pro access will continue until the end of your billing period.",
  "account.pro_status.cancel_confirm_description":
    "This will permanently cancel your Subscription.",
  "account.pro_status.cancel_error":
    "We couldn't cancel your Subscription. Please try again later.",

  "account.usage_statistics.title": "Usage Statistics",
  "account.usage_statistics.description": "Your current usage statistics.",
  "account.usage_statistics.remove_limits": "Remove all limits with Pro",
  "account.usage_statistics.upgrade_to_pro": "Upgrade to Pro",
  "account.usage_statistics.health_areas": "Health Areas",
  "account.usage_statistics.goals": "Goals",
  "account.usage_statistics.routines": "Routines",
  "account.usage_statistics.ai_suggestions": "AI Suggestions",

  "account.update_email.title": "Update email",
  "account.update_email.description":
    "Change your email to keep your account linked to the right contact.",

  "account.update_password.title": "Update password",
  "account.update_password.description":
    "Set a strong password to keep your account secure. Make sure it's unique and easy for you to remember.",
  "account.update_password.send_reset_email": "Send Reset Email",
  "account.update_password.reset_sent_title": "Password reset link sent!",
  "account.update_password.reset_sent_description":
    "If you have an account, we have sent you a password reset link.",
  "account.update_password.reset_error_title": "Oops! Something went wrong.",
  "account.update_password.reset_error_description":
    "We couldn't send the password reset email. Please try again later.",

  "account.delete_account.title": "Delete Account",
  "account.delete_account.description":
    "Ready to leave? Permanently delete your account and all related data such as your routines.",
  "account.delete_account.button": "Delete Account",
  "account.delete_account.success_title": "Success",
  "account.delete_account.success_description": "Your account has been deleted.",
  "account.delete_account.error_title": "Error",
  "account.delete_account.error_description": "Failed to delete your account. Please try again.",

  // Profile Page Components
  "profile.form_card.title": "Update profile",
  "profile.form_card.description": "Update your profile information.",
  "profile.avatar_card.title": "Profile Avatar",
  "profile.avatar_card.description": "Select your profile avatar from the options below.",
  "profile.avatar_card.change_button": "Change Avatar",
  "profile.avatar_card.select_title": "Select Avatar",
  "profile.avatar_card.error_title": "Error",
  "profile.avatar_card.error_description": "Failed to update your avatar. Please try again.",
  "profile.avatar_card.no_user_error": "No user ID found. Please try again.",

  // Command Menu
  "command_menu.open_command_menu": "Open command menu",
  "command_menu.search_placeholder": "Search...",
  "command_menu.search_input_placeholder": "Type a command or search...",
  "command_menu.no_results": "No results found.",
  "command_menu.links": "Links",
  "command_menu.commands": "Commands",
  "command_menu.account": "Account",
  "command_menu.theme": "Theme",
  "command_menu.social": "Social",
  "command_menu.progressmade_health_pro": "ProgressMade Health Pro",
  "command_menu.get_help_or_share_contact": "Get Help or Share Contact",
  "command_menu.rate_us": "Rate Us",
  "command_menu.light": "Light",
  "command_menu.dark": "Dark",
  "command_menu.join_whatsapp_community": "Join WhatsApp Community",
  "command_menu.linkedin": "LinkedIn",
  "command_menu.x": "X",
  "command_menu.instagram": "Instagram",
  "command_menu.tiktok": "TikTok",

  // Dashboard
  "dashboard.good_morning": "Good Morning",
  "dashboard.good_afternoon": "Good Afternoon",
  "dashboard.good_evening": "Good Evening",
  "dashboard.routines_for_today": "Routines for today",
  "dashboard.upcoming_routines": "Upcoming routines",
  "dashboard.completed_routines": "Completed routines",
  "dashboard.weekly_progress": "Weekly Progress",
  "dashboard.share": "Share",
  "dashboard.completed": "Completed",
  "dashboard.remaining": "Remaining",
  "dashboard.routines": "Routines",

  // Calendar Navigation
  "calendar.nav.day": "Day",
  "calendar.nav.week": "Week",
  "calendar.nav.month": "Month",
  "calendar.nav.list": "List",
  "calendar.nav.today": "Today",
  "calendar.nav.previous": "Previous",
  "calendar.nav.next": "Next",

  // Calendar List View
  "calendar.list_view.day_complete": "Day Complete",

  // Forms
  "forms.email": "Email",
  "forms.password": "Password",
  "forms.email_placeholder": "me@example.com",
  "forms.password_placeholder": "****",
  "forms.login": "Login",
  "forms.reset_password": "Reset Password",
  "forms.forgot_password_link": "Forgot your password?",
  "forms.invalid_email": "Invalid email address",
  "forms.password_required": "Password is required",
  "forms.invalid_email_or_password": "Invalid email or password",
  "forms.login_error": "Unable to login. Please try again.",
  "forms.login_error_generic": "An error occurred during login. Please try again.",

  // Global Error
  "global_error.title": "Something went wrong",
  "global_error.description": "We're sorry, but there was an error loading this page.",
  "global_error.team_notified": "Our team has been notified and we're working to fix the issue.",
  "global_error.refresh": "Refresh",

  // Auth Pages
  "auth.login.page_title": "Login",
  "auth.login.page_description": "Login to your account to get started.",
  "auth.register.page_title": "Sign up with Email",
  "auth.register.page_description": "Create an account to get started.",

  // Newsletter Page
  "newsletter.page.title": "Join Newsletter",
  "newsletter.page.description": "You will receive regular updates on {appName}.",

  // Confirm Delete Dialog
  "confirm_delete.title": "Are you absolutely sure?",
  "confirm_delete.description":
    "This will permanently delete your account and remove your data from the servers.",
  "confirm_delete.cancel": "Cancel",
  "confirm_delete.confirm": "Confirm",

  // Auth Error Page
  "auth_error.title": "Authentication Error",
  "auth_error.description": "We encountered an issue with your sign-in attempt",
  "auth_error.problem_description":
    "There was a problem authenticating your account. This could be due to:",
  "auth_error.reason_session_expired": "Your authentication session expired.",
  "auth_error.reason_provider_unavailable":
    "The authentication provider (Google or Apple) is temporarily unavailable.",
  "auth_error.reason_permission_denied": "You denied permission for the requested access.",
  "auth_error.reason_network_issue": "There was a network connectivity issue.",
  "auth_error.help_text":
    "Please try signing in again. If the problem persists, contact our support team for assistance.",
  "auth_error.go_home": "Go Home",
  "auth_error.contact_support": "Contact Support",

  // Custom Error Component
  "custom_error.title": "Error",
  "custom_error.description": "An error occurred while fetching data.",
  "custom_error.unknown_error": "Unknown error",

  // Dashboard Circle
  "dashboard.circle.todays_progress": "Today's Progress",
  "dashboard.circle.progress_tooltip":
    "Shows the percentage of routine steps you've completed today. Complete all steps in your routines to reach 100%.",
  "dashboard.circle.progress_title": "Progress Circle",
  "dashboard.circle.steps_completed": "{completed} out of {total} steps",
  "dashboard.circle.routines_completed": "{completed} out of {total} routines",
  "dashboard.circle.all_done": "All completed!",
  "dashboard.circle.keep_going": "Keep going!",
  "dashboard.circle.switch_to_weekly": "View Weekly",
  "dashboard.circle.switch_to_daily": "View Daily",

  // Dashboard Goals
  "dashboard.goals.other_goals": "Other Goals",
  "dashboard.goals.no_goals_in_health_area": "No goals assigned to this health area",

  // Sort Dropdown
  "sort.by_health_area": "Sort by Health Area",
  "sort.manual": "Sort Manually",

  // New Resource Card
  "new_resource.health_area.title": "New Health Area",
  "new_resource.health_area.description":
    "Create a new health area to organize your goals and routines.",
  "new_resource.goal.title": "New Goal",
  "new_resource.goal.description": "Create a new goal to track your progress and achievements.",
  "new_resource.routine.title": "New Routine",
  "new_resource.routine.description":
    "Create a new routine to build healthy habits and consistency.",

  // Goal Card
  "goal_card.added": "Added",
  "goal_card.add_goal": "Add Goal",
  "goal_card.goal_added_tooltip": "Goal is added to your account",

  // Routine Card
  "routine_card.added": "Added",
  "routine_card.add_routine": "Add Routine",
  "routine_card.routine_added_tooltip": "Routine is added to your account",
  "routine_card.daily": "Daily",
  "routine_card.planned_for": "You have planned this routine for {days}.",
  "routine_card.steps": "steps",
  "routine_card.step": "step",

  // Manage Resource
  "manage_resource.add": "Add",
  "manage_resource.edit": "Edit",
  "manage_resource.create_description":
    "Define your new {resource} and it will be added to your progress dashboard.",
  "manage_resource.update_description": "Update your {resource}.",

  // Manage Health Area
  "manage_health_area.add_title": "Add Health Area",
  "manage_health_area.edit_title": "Edit Health Area",
  "manage_health_area.create_description":
    "Define your new health area and it will be added to your progress dashboard.",
  "manage_health_area.update_description": "Update your health area.",

  // Manage Goal
  "manage_goal.add_title": "Add Goal",
  "manage_goal.edit_title": "Edit Goal",
  "manage_goal.create_description":
    "Define your new goal and it will be added to your progress dashboard.",
  "manage_goal.update_description": "Update your goal.",

  // Manage Routine
  "manage_routine.add_title": "Add Routine",
  "manage_routine.edit_title": "Edit Routine",
  "manage_routine.create_description":
    "Define your new routine and it will be added to your progress dashboard.",
  "manage_routine.update_description": "Update your routine.",

  // Forgot Password Page
  "forgot_password.page_title": "Forgot your password?",
  "forgot_password.page_description": "Enter your email to reset your password.",

  // Blog Detail
  "blog.back_to_overview": "Back to Overview",

  // Hook Error Messages
  "hooks.error.failed_suggest_goal": "Failed to suggest goal",
  "hooks.error.suggest_goal_description": "Please try again or create a goal manually.",
  "hooks.error.failed_suggest_routine": "Failed to suggest routine",
  "hooks.error.suggest_routine_description": "Please try again or create a routine manually.",
  "hooks.error.failed_suggest_steps": "Failed to suggest steps",
  "hooks.error.suggest_steps_description": "Please try again or add steps manually.",
  "hooks.error.updating_goals_order": "Error updating goals order",
  "hooks.error.updating_routines_order": "Error updating routines order",
  "hooks.error.logout_issue": "There was an issue logging out. Please try again.",
  "hooks.error.purchase_failed": "Purchase Failed",
  "hooks.error.purchase_request_error": "Error sending purchase request",
  "hooks.error.notifications_blocked": "Notifications are blocked",
  "hooks.error.enable_notifications_browser":
    "Please enable notifications in your browser settings",
  "hooks.error.failed_add_resource": "Failed to add {resource}",
  "hooks.error.failed_update_resource": "Failed to update {resource}",
  "hooks.error.failed_delete_resource": "Failed to delete {resource}",
  "hooks.error.no_resource_id": "No resource ID found for update",
  "hooks.success.deleted_resource": "You deleted {title}",

  // Resource Actions
  "resource_actions.edit": "Edit {resource}",
  "resource_actions.delete": "Delete {resource}",
  "resource_actions.add_goal": "Add Goal",
  "resource_actions.add_routine": "Add Routine",
  "resource_actions.suggest_goal": "Suggest Goal",
  "resource_actions.suggest_routine": "Suggest Routine",
  "resource_actions.generating": "Generating...",
  "resource_actions.generating_goal": "Generating Goal...",
  "resource_actions.generating_routine": "Generating Routine...",

  // Resource Labels
  "resource_labels.health_area.singular": "Health Area",
  "resource_labels.health_area.plural": "Health Areas",
  "resource_labels.goal.singular": "Goal",
  "resource_labels.goal.plural": "Goals",
  "resource_labels.routine.singular": "Routine",
  "resource_labels.routine.plural": "Routines",

  // Theme Switcher
  "theme.toggle": "Toggle theme",

  // Search Input
  "search_input.select": "Select {resource}...",
  "search_input.selected": "{count} {resource} selected",
  "search_input.search_placeholder": "Search {resource}...",
  "search_input.no_results": "No {resource} found.",

  // Items Input
  "items_input.title": "Title",
  "items_input.title_placeholder": "Enter {itemType} title",
  "items_input.description": "Description",
  "items_input.description_placeholder": "Enter {itemType} description (optional)",
  "items_input.add": "Add",
  "items_input.edit": "Edit",
  "items_input.add_item": "Add {itemType}",
  "items_input.edit_item": "Edit {itemType}",
  "items_input.description_text": "Your {itemType} has {count} {itemTypePlural}.",
  "items_input.max_reached": "Maximum number of {itemType} reached.",
  "items_input.dialog_description": "Enter a title for this {itemType}{context}{optional}.",

  // Items Input - Goal specific
  "items_input.goal.title": "Goal Title",
  "items_input.goal.title_placeholder": "Enter goal title",
  "items_input.goal.description": "Goal Description",
  "items_input.goal.description_placeholder": "Enter goal description (optional)",
  "items_input.goal.add": "Add Goal",
  "items_input.goal.edit": "Edit Goal",
  "items_input.goal.add_item": "Add Goal",
  "items_input.goal.edit_item": "Edit Goal",
  "items_input.goal.description_text":
    "Your goal has {count} {count, plural, one {item} other {items}}.",
  "items_input.goal.max_reached": "Maximum number of goals reached.",
  "items_input.goal.dialog_description": "Enter a title for this goal{optional}.",

  // Items Input - Routine specific
  "items_input.routine.title": "Routine Title",
  "items_input.routine.title_placeholder": "Enter routine title",
  "items_input.routine.description": "Routine Description",
  "items_input.routine.description_placeholder": "Enter routine description (optional)",
  "items_input.routine.add": "Add Routine",
  "items_input.routine.edit": "Edit Routine",
  "items_input.routine.add_item": "Add Routine",
  "items_input.routine.edit_item": "Edit Routine",
  "items_input.routine.description_text":
    "Your routine has {count} {count, plural, one {item} other {items}}.",
  "items_input.routine.max_reached": "Maximum number of routines reached.",
  "items_input.routine.dialog_description": "Enter a title for this routine{optional}.",

  // Items Input - Step specific
  "items_input.step.title": "Step Title",
  "items_input.step.title_placeholder": "Enter step title",
  "items_input.step.description": "Step Description",
  "items_input.step.description_placeholder": "Enter step description (optional)",
  "items_input.step.add": "Add Step",
  "items_input.step.edit": "Edit Step",
  "items_input.step.add_item": "Add Step",
  "items_input.step.edit_item": "Edit Step",
  "items_input.step.description_text":
    "Your routine has {count} {count, plural, one {step} other {steps}}.",
  "items_input.step.max_reached": "Maximum number of steps reached.",
  "items_input.step.dialog_description": "Enter a title for this step in your routine{optional}.",

  // Filtered Routines
  "filtered_routines.amazing_work": "Amazing work!",
  "filtered_routines.crushed_routines": "You've crushed all your routines today.",
  "filtered_routines.keep_momentum": "Keep this momentum going!",
  "filtered_routines.incredible_progress": "You're making incredible progress",
  "filtered_routines.no_active_routines": "No active routines",
  "filtered_routines.create_new_routine":
    "Create a new routine to start tracking your health progress!",
  "filtered_routines.no_upcoming_routines":
    "No upcoming routines. All your routines are active today.",
  "filtered_routines.no_completed_routines":
    "No completed routines. All your routines are active today.",

  // Health Area Routines
  "health_area_routines.no_routines": "No routines assigned to this health area",

  // Routines Toggle
  "routines_toggle.today": "Today",
  "routines_toggle.completed": "Completed",
  "routines_toggle.upcoming": "Upcoming",
  "routines_toggle.week": "Weekly",

  // Time Period Toggle
  "time_period_toggle.day": "Day",
  "time_period_toggle.week": "Week",

  // Routine Form
  "routine_form.title": "Title",
  "routine_form.title_placeholder": "Title of your {mode} routine",
  "routine_form.title_required": "Title is required",
  "routine_form.new": "new",
  "routine_form.updated": "updated",
  "routine_form.description": "Description",
  "routine_form.description_placeholder": "Provide details about your routine.",
  "routine_form.routine_steps": "Routine Steps",
  "routine_form.suggesting_steps": "Suggesting Steps...",
  "routine_form.regenerate_steps": "Regenerate Steps",
  "routine_form.suggest_steps": "Suggest Steps",
  "routine_form.color": "Color",
  "routine_form.icon": "Icon",
  "routine_form.tap_to_change_icon": "Tap to change icon",
  "routine_form.click_to_change_icon": "Click to change icon",
  "routine_form.daily_routine": "Daily Routine",
  "routine_form.daily_routine_description": "Do this routine every day.",
  "routine_form.no_specific_time": "No Specific Time",
  "routine_form.no_specific_time_description": "Don't set a specific time.",
  "routine_form.please_select_at_least_one_day": "Please select at least one day",
  "routine_form.select_days_no_time":
    "Please select the days you want to plan this routine (no specific times needed).",
  "routine_form.select_days_with_time":
    "Please select the days and times you want to plan this routine.",
  "routine_form.planned_days_no_time":
    "You have planned this routine on {days} (no specific times).",
  "routine_form.planned_days_with_time": "You have planned this routine on {days}.",
  "routine_form.saving": "Saving...",

  // Goal Form
  "goal_form.icon": "Icon",
  "goal_form.tap_to_change_icon": "Tap to change icon",
  "goal_form.click_to_change_icon": "Click to change icon",
  "goal_form.title": "Title",
  "goal_form.title_required": "Title is required",
  "goal_form.title_placeholder": "Title of your {mode} goal",
  "goal_form.new": "new",
  "goal_form.updated": "updated",
  "goal_form.description": "Description",
  "goal_form.description_placeholder": "Provide details about this goal.",
  "goal_form.target_date": "Target Date",
  "goal_form.target_date_placeholder": "Select a target date",
  "goal_form.target_date_description": "When do you aim to complete this goal?",
  "goal_form.target_date_future": "Target date must be in the future",
  "goal_form.save_failed": "Failed to save goal. Please try again.",
  "goal_form.saving": "Saving...",

  // Health Area Form
  "health_area_form.select_health_area": "Select a health area",
  "health_area_form.health_area": "Health Area",
  "health_area_form.title_required": "Title is required",
  "health_area_form.save_failed": "Failed to save health area. Please try again.",
  "health_area_form.goals": "Goals",
  "health_area_form.goal_count": "Your goal consists of {count} {plural}.",
  "health_area_form.routines": "Routines",
  "health_area_form.routine_count": "Your goal consists of {count} {plural}.",
  "health_area_form.saving": "Saving...",

  // Suggestion Cards
  "routine_suggestion.accept": "Accept",
  "routine_suggestion.reject": "Reject",
  "goal_suggestion.accept": "Accept",
  "goal_suggestion.reject": "Reject",

  // Health Area Card
  "health_area_card.add_health_area": "Add Health Area",
  "health_area_card.added_message": "Health Area is added to your account",
  "health_area_card.goals": "goals",
  "health_area_card.goal": "goal",
  "health_area_card.routines": "routines",
  "health_area_card.routine": "routine",

  // Health Area
  "health_area.create_goal_description":
    "Create a {healthArea} goal to measure your success and stay motivated.",
  "health_area.create_routine_description":
    "Build consistent {healthArea} habits with a daily routine that drives progress.",

  // Health Areas Page
  "health_areas_page.explore_more": "Explore more health areas",
  "health_areas_page.explore_more_routines": "Explore more routines",
  "health_areas_page.explore_more_goals": "Explore more goals",

  // Privacy Policy
  "privacy_policy.title": "Privacy Policy",
  "privacy_policy.last_updated": "Last updated",

  // Terms of Service
  "terms_of_service.title": "Terms of Service",
  "terms_of_service.last_updated": "Last updated",

  // Settings Page
  "settings.title": "Settings",
  "settings.pro_member": "Pro Member",
  "settings.free_member": "Free Member",
  "settings.welcome_to": "Welcome to",
  "settings.sign_in_description": "Sign in to access your personalized experience",
  "settings.login": "Login",
  "settings.sign_up": "Sign Up",
  "settings.register": "Register",
  "settings.account": "Account",
  "settings.profile_settings": "Profile Settings",
  "settings.account_settings": "Account Settings",
  "settings.achieve_more": "Achieve More",
  "settings.upgrade_to_pro": "Upgrade to Pro",
  "settings.preferences": "Preferences",
  "settings.notification_settings": "Notification Settings",
  "settings.calendar_settings": "Calendar Settings",
  "settings.theme": "Theme",
  "settings.support": "Support",
  "settings.contact": "Contact",
  "settings.join_whatsapp_community": "Join WhatsApp Community",
  "settings.follow_social_media": "Follow on Social Media",
  "settings.rate_us": "Rate Us",
  "settings.share_with_friends": "Share with Friends",
  "settings.share_text": "Check out {appName} - Track and achieve your health goals!",
  "settings.resources": "Resources",
  "settings.blog": "Blog",
  "settings.changelog": "Changelog",
  "settings.more": "More",
  "settings.logout": "Logout",
  "settings.delete_account.title": "Delete Account",
  "settings.delete_account.error_title": "Error",
  "settings.delete_account.error_description": "Failed to delete your account. Please try again.",
  "settings.delete_account.success_title": "Success",
  "settings.delete_account.success_description": "Your account has been deleted.",

  // Library Page
  "library.description":
    "Explore various health areas, each offering predefined goals and routines to kickstart your journey towards better health.",
  "library.no_routines_or_goals_available": "No routines or goals available in this category yet.",

  // Resource Dropdown
  "resource_dropdown.delete_confirmation": "This will permanently delete your {resource} {title}.",
  "resource_dropdown.actions": "{resource} Actions",

  // Resource Context Menu
  "resource_context_menu.delete_confirmation":
    "This will permanently delete your {resource} {title}.",
  "resource_context_menu.actions": "{resource} Actions",

  // Edit Delete Dropdown
  "edit_delete_dropdown.delete_confirmation": "This will permanently delete {title}.",
  "edit_delete_dropdown.edit": "Edit",
  "edit_delete_dropdown.delete": "Delete",

  // Draggable List
  "draggable_list.step_actions": "Step Actions",

  // Social Drawer
  "social_drawer.title": "Follow ProgressMade.AI",
  "social_drawer.description": "Connect with us on social media",
  "social_drawer.join_whatsapp_community": "Join WhatsApp Community",
  "social_drawer.linkedin": "LinkedIn",
  "social_drawer.x": "X",
  "social_drawer.instagram": "Instagram",
  "social_drawer.tiktok": "TikTok",

  // Routines by Health Area
  "routines_by_health_area.other_routines": "Other Routines",

  // Health Areas
  "health_areas.nutrition.title": "Nutrition",
  "health_areas.nutrition.description":
    "Cultivate healthy eating habits and optimize your nutrition for overall wellness.",
  "health_areas.energy.title": "Energy",
  "health_areas.energy.description": "Boost and maintain your energy levels throughout the day.",
  "health_areas.fitness.title": "Fitness",
  "health_areas.fitness.description":
    "Improve strength, endurance and overall physical condition through regular exercise.",
  "health_areas.heart.title": "Heart",
  "health_areas.heart.description":
    "Support cardiovascular health through targeted habits and activities.",
  "health_areas.hydration.title": "Hydration",
  "health_areas.hydration.description":
    "Ensure adequate water intake throughout the day for optimal bodily function.",
  "health_areas.mental.title": "Mental",
  "health_areas.mental.description":
    "Support cognitive health and mental well-being through dedicated practices.",
  "health_areas.mood.title": "Mood",
  "health_areas.mood.description":
    "Enhance emotional balance, resilience, and mindfulness for improved mood and outlook.",
  "health_areas.movement.title": "Movement",
  "health_areas.movement.description":
    "Incorporate regular movement into your daily routine for better health.",
  "health_areas.sleep.title": "Sleep",
  "health_areas.sleep.description":
    "Improve sleep quality and establish consistent sleep routines for better health.",
  "health_areas.stress.title": "Stress",
  "health_areas.stress.description":
    "Develop effective strategies to cope with stress and maintain a calm mindset.",
  "health_areas.weight.title": "Weight",
  "health_areas.weight.description":
    "Achieve and maintain a healthy weight through sustainable lifestyle changes.",

  // Day Time Selector
  "day_time_selector.monday": "Monday",
  "day_time_selector.tuesday": "Tuesday",
  "day_time_selector.wednesday": "Wednesday",
  "day_time_selector.thursday": "Thursday",
  "day_time_selector.friday": "Friday",
  "day_time_selector.saturday": "Saturday",
  "day_time_selector.sunday": "Sunday",
  "day_time_selector.monday_short": "M",
  "day_time_selector.tuesday_short": "T",
  "day_time_selector.wednesday_short": "W",
  "day_time_selector.thursday_short": "T",
  "day_time_selector.friday_short": "F",
  "day_time_selector.saturday_short": "S",
  "day_time_selector.sunday_short": "S",
  "day_time_selector.every_day": "Every day",
  "day_time_selector.select_time": "Select time",

  // Progress Notifications
  "progress_notifications.daily_goal_achieved": "Daily Goal Achieved",
  "progress_notifications.daily_goal_achieved_description":
    "You completed your 10,000 steps today!",
  "progress_notifications.water_reminder": "Water Reminder",
  "progress_notifications.water_reminder_description": "Time to drink your 8th glass of water",
  "progress_notifications.workout_completed": "Workout Completed",
  "progress_notifications.workout_completed_description":
    "You finished your 30 minute cardio session",
  "progress_notifications.new_achievement": "New Achievement",
  "progress_notifications.new_achievement_description": "You've reached a 5-day exercise streak!",
  "progress_notifications.nutrition_goal": "Nutrition Goal",
  "progress_notifications.nutrition_goal_description": "You hit your fruit intake target for today",
  "progress_notifications.todays_routines": "Today's Routines",
  "progress_notifications.todays_routines_description": "You have 3 routines scheduled for today",
  "progress_notifications.meditation_reminder": "Meditation Reminder",
  "progress_notifications.meditation_reminder_description":
    "Time for your afternoon mindfulness session",
  "progress_notifications.weekly_progress": "Weekly Progress",
  "progress_notifications.weekly_progress_description":
    "You're 85% toward your weekly fitness goal",
  "progress_notifications.consistency_reward": "Consistency Reward",
  "progress_notifications.consistency_reward_description":
    "You have been consistent for 10 days in a row",
  "progress_notifications.rest_day": "Rest Day",
  "progress_notifications.rest_day_description": "Tomorrow is a scheduled recovery day",
  "progress_notifications.time_15m_ago": "15m ago",
  "progress_notifications.time_10m_ago": "10m ago",
  "progress_notifications.time_5m_ago": "5m ago",
  "progress_notifications.time_2m_ago": "2m ago",
  "progress_notifications.time_just_now": "Just now",
  "progress_notifications.time_4h_ago": "4h ago",
  "progress_notifications.time_3m_ago": "3m ago",
  "progress_notifications.time_1h_ago": "1h ago",
  "progress_notifications.time_2h_ago": "2h ago",
  "progress_notifications.time_30m_ago": "30m ago",

  // Share Progress
  "share_progress.share_title": "My Weekly Progress",
  "share_progress.share_text":
    "I completed {percentage}% of my routines this week! 💪\n\nSchedule your health at https://progressmade.ai",
  "share_progress.no_active_routines":
    "No active routines to display. Create some routines to track your progress!",
  "share_progress.powered_by": "Powered by {appName}.ai",
  "share_progress.share_button": "Share",

  // Android Review Dialog
  "android_review_dialog.title": "Enjoying ProgressMade?",
  "android_review_dialog.description":
    "If you're loving the app, would you mind taking a moment to rate us on Google Play? It really helps us out and takes less than a minute.",
  "android_review_dialog.rate_button": "Rate on Google Play",
  "android_review_dialog.later_button": "Maybe Later",
  "android_review_dialog.no_thanks_button": "No Thanks",
};

export default messages;
